import { ReactNode } from 'react';
import { getConvertedDate } from '@factorin/util';
import { subMonths } from 'date-fns';
import { FormApi } from 'final-form';

import { TFunction } from 'Modules/core/i18n';


export enum RangeButtonsTypes {
    Now ='Now',
    Month = 'Month',
    ThreeMonth = 'ThreeMonth',
    HalfYear = 'HalfYear',
}

enum OffsetDatesCounts {
    OneMonth = 1,
    ThreeMonth = 3,
    HalfYear = 6,
}

type ButtonsConfigs = Record<RangeButtonsTypes, {
    name: ReactNode;
    handler: () => void;
}>;

type GetRangeButtonsConfigs = (filterNames: [string, string], change: FormApi['change'], t: TFunction) => ButtonsConfigs;


const changeDataValues = (offsetCount: OffsetDatesCounts, filterNames: [string, string], change: FormApi['change']) => {
    const nowDate = new Date();
    const now = getConvertedDate('UTCFormat', nowDate);
    const previousDate = getConvertedDate('UTCFormat', subMonths(nowDate, offsetCount));

    change(filterNames[0], previousDate);
    change(filterNames[1], now);
};

export const getRangeButtonsConfigs: GetRangeButtonsConfigs = (filterNames, change, t) => ({
    [RangeButtonsTypes.Now]: {
        name: t('now'),
        handler: () => {
            const now = getConvertedDate('UTCFormat', new Date());

            change(filterNames[0], now);
            change(filterNames[1], now);
        },
    },

    [RangeButtonsTypes.Month]: {
        name: t('month'),
        handler: () => changeDataValues(OffsetDatesCounts.OneMonth, filterNames, change),
    },

    [RangeButtonsTypes.ThreeMonth]: {
        name: t('threeMonth'),
        handler: () => changeDataValues(OffsetDatesCounts.ThreeMonth, filterNames, change),
    },

    [RangeButtonsTypes.HalfYear]: {
        name: t('halfYear'),
        handler: () => changeDataValues(OffsetDatesCounts.HalfYear, filterNames, change),
    },
});
